import { AGENT_TYPE } from "src/app/product-capture/model/consts/agent-type.const";
import { TableCols } from "../interfaces/static-data";
import { leiFormatValidator } from "../../validators/lei-format.validator";
import { Validators } from "@angular/forms";

export const AGENTS: TableCols[] = [
    {
        key: 'type',
        displayValue: 'Type',
        type: 'select',
        items: AGENT_TYPE,
        selectOptions: {
            searchable: true,

        }
    },
    {
        key: 'entityName',
        displayValue: 'Entity Name',
    },
    {
        key: 'lei',
        displayValue: 'LEI',
        validators: [Validators.required,leiFormatValidator()],
    },
    {
      key: 'workflowStatus',
      displayValue: 'Workflow Status',
      hideOnForm: true
    },
    {
      key: 'lastUpdatedBy',
      displayValue: 'Last Updated By',
      hideOnForm: true
    },
    {
      key: 'updatedOn',
      displayValue: 'Updated On',
      hideOnForm: true
    },
    {
      key: 'deletedAt',
      displayValue: 'Deleted On',
      hideOnForm: true
    }
]

export interface Agent {
    id: number;
    type: string;
    entityName: string;
    lei?: string;
    productId?: string;
}

export interface AgentEntity {
    entityName: string;
    lei?: string;
}
